import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { List } from 'immutable';

@Injectable({
  providedIn: 'root',
})
/**
 * Service that handles navigating through app
 */
export class NavigationService {
  private history = List<string>();

  /**
   * @constructor
   */
  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history = this.history.push(event.urlAfterRedirects);
      }
    });
  }

  /**
   * Returns to previous page, if existant
   * if not, to root page
   */
  async back() {
    this.history = this.history.pop();
    if (this.history.size > 0) {
      this.history = this.history.pop();
      this.location.back();
    } else {
      await this.router.navigate(['/']);
    }
  }

  /**
   * Reloads components in current page
   */
  async reload() {
    const restoreConfig = {
      shouldReuseRoute: this.router.routeReuseStrategy.shouldReuseRoute,
      onSameUrlNavigation: this.router.onSameUrlNavigation,
    };

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    await this.router.navigateByUrl(this.router.url);
    this.router.routeReuseStrategy.shouldReuseRoute =
      restoreConfig.shouldReuseRoute;
    this.router.onSameUrlNavigation = restoreConfig.onSameUrlNavigation;
  }
}
